import { useMemo, useState } from "react";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useIsMobile } from "@/hooks/use-mobile";
import { useRepackShrinkage } from "@/hooks/use-repack-shrinkage";

import { RepackShrinkageFilterBar } from "./repack-shrinkage-filter-bar";
import { RepackShrinkageMobileList } from "./repack-shrinkage-mobile-list";
import { RepackShrinkageSummaryCards } from "./repack-shrinkage-summary-cards";
import { RepackShrinkageTable } from "./repack-shrinkage-table";
import { filterShrinkageItems } from "./repacking-utils";

export function RepackShrinkageTab() {
  const isMobile = useIsMobile();

  // Filters
  const [searchQuery, setSearchQuery] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [rawMaterialId, setRawMaterialId] = useState("");

  const { data, isLoading } = useRepackShrinkage({
    startDate: startDate || undefined,
    endDate: endDate || undefined,
    rawMaterialId: rawMaterialId || undefined,
  });

  const rawItems = useMemo(() => data?.items || [], [data?.items]);
  const totalShrinkageValue = data?.totalShrinkageValue || 0;

  // API already sorts by highest shrinkage percentage
  const filteredItems = useMemo(
    () => filterShrinkageItems(rawItems, searchQuery),
    [rawItems, searchQuery],
  );

  function handleResetFilters() {
    setSearchQuery("");
    setStartDate("");
    setEndDate("");
    setRawMaterialId("");
  }

  return (
    <div className="space-y-6">
      {/* KPI Cards */}
      <RepackShrinkageSummaryCards
        items={rawItems}
        totalShrinkageValue={totalShrinkageValue}
      />

      {/* Main Table / List Card */}
      <Card className="shadow-xs">
        <CardHeader className="p-4 sm:p-6 space-y-4">
          <div className="flex flex-col gap-1">
            <CardTitle className="text-base font-semibold">
              Laporan Susut Repacking
            </CardTitle>
            <p className="text-xs text-muted-foreground">
              Perbandingan kuantitas target (expected yield) dan hasil aktual
              timbangan per bahan resep.
            </p>
          </div>

          <RepackShrinkageFilterBar
            searchQuery={searchQuery}
            onSearchQueryChange={setSearchQuery}
            startDate={startDate}
            endDate={endDate}
            onDateRangeChange={(from, to) => {
              setStartDate(from);
              setEndDate(to);
            }}
            rawMaterialId={rawMaterialId}
            onRawMaterialIdChange={setRawMaterialId}
            onReset={handleResetFilters}
          />
        </CardHeader>

        <CardContent className="p-0">
          {isLoading ? (
            <div className="p-12 text-center text-xs text-muted-foreground">
              Memuat data laporan susut...
            </div>
          ) : isMobile ? (
            <RepackShrinkageMobileList items={filteredItems} />
          ) : (
            <RepackShrinkageTable items={filteredItems} />
          )}
        </CardContent>
      </Card>
    </div>
  );
}
